import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { MoTradeReleaseCommentEditCellRendererParams } from '@ddv/data-grid';
import { ManagerService } from '@ddv/layout';
import { IconComponent } from '@hs/ui-core-presentation';

@Component({
    selector: 'app-mo-trade-release-comment-cell-renderer',
    styleUrls: ['./mo-trade-release-comment-cell-renderer.component.scss'],
    templateUrl: './mo-trade-release-comment-cell-renderer.component.html',
    imports: [
        IconComponent,
    ],
    host: {
        '[class.edited]': 'edited',
    },
})
export class MoTradeReleaseCommentCellRendererComponent implements ICellRendererAngularComp {
    protected edited = false;
    protected value = '';

    constructor(private readonly manager: ManagerService) {}

    agInit(params: MoTradeReleaseCommentEditCellRendererParams): void {
        this.edited = !!params.eParentOfValue?.classList.contains('ag-cell-edited');
        this.value = params.value ?? '';
    }

    refresh(_: ICellRendererParams): boolean {
        return false;
    }
}
